import React, { FC, useState } from "react";
import { Table, Popconfirm, notification } from "antd";

import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { IResultResponse } from "../../models/response/result.model";
import SubscribesService from "../../services/subscribes.service";

const List: FC = () => {
  const [deletedUser, setDeletedUser] = useState<any>(null);
  const [updateTrigger, setUpdateTrigger] = useState<number>(0);

  const { fetchedData, loading } = useHttpGet<IResultResponse<any[]>>(
    `${APIRoutes.SUNSCRIBERS}`,
    {
      dependencies: [deletedUser, updateTrigger],
      defaultValue: {} as IResultResponse<any[]>,
      reject: CommonService.showAllErrors,
    }
  );

  const deleteUserSubscription = async (id: number) => {
    try {
      await SubscribesService.delete(id);

      notification.success({
        message: `Subscription has been deleted`,
      });

      setUpdateTrigger(new Date().getMilliseconds());
      setDeletedUser(id);
    } catch (errors) {
      CommonService.showAllErrors(errors);
    }
  };

  const columns = [
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "",
      dataIndex: "id",
      render: (text: any, record: any) => {
        return (
          <Popconfirm
            title="Are you sure you want to delete this item?"
            onConfirm={() => deleteUserSubscription(record?.id)}
            onCancel={() => { }}
            okText="Yes"
            cancelText="No"
          >
            Delete
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={fetchedData.result || []}
      pagination={false}
      rowKey="id"
      loading={loading}
      size="small"
    />
  );
};

export default List;
